import ConfirmationModal from 'components/common/ConfirmationMessage';
import { ListLayout } from 'components/common/ListLayout';
import TableHeaderItem from 'components/common/ListLayout/TableHeaderItem';
import React, { useMemo } from 'react'
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useNavigation } from 'react-router-dom';
import { MainAccountDashboardSelector } from 'slices/mainAccount/dashboardSlice';
import { fetchMainAccountDashboardAppointments } from 'slices/mainAccount/dashboardSlice';
import { getEyeStyle, getBackgroundStyle } from 'components/common/TableColor';
import moment from "moment";
import { useTranslation } from "react-i18next";

const ListTable = ({ data, total, filters, setPageLength }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [addForm, setAddForm] = React.useState({
        show: false,
        item: {}
    });
    const refAddutton = React.useRef(null);

    const [selectedItems, setSelectedItems] = React.useState([]);
    const [selectAll, setSelectAll] = React.useState(false);
    const [declineModal, setDeclineModal] = React.useState(
        {
            show: false,
            item: {}
        }
    );
    const [currentPage, setCurrentPage] = React.useState(1);
    const [searchTerm, setSearchTerm] = React.useState("");
    const [sortConfig, setSortConfig] = React.useState({
        sortBy: 'id',
        sortDirection: 'desc',
    });;
    const [sortFields, setSortFields] = React.useState([]);

    const [actionAccept, setActionAccept] = React.useState({
        show: false,
        item: {}
    });
    const { last_page: totalPages, current_page, per_page: pageLength } = useSelector(MainAccountDashboardSelector);

    const handleAddScheduleListPopUp = (item) => {
        setAddForm({
            show: true,
            item,
        });
    };
    const submitCallback = (status, message) => {
        if (status) {
            toast.success(message, {
                className: "successToast",
            })
            setSelectedItems([]);
            setSelectAll(false)
            // dispatch(fetchMainAccountDashboardAppointments())
            hideConfirmDialog()
        }
        else {
            toast.error(message,
                {
                    className: "errorToast",
                }
            );
        }
    };
    const showConfirmDialog = () => {
        setDeclineModal(true);
        return
    };
    const hideConfirmDialog = () => {
        setDeclineModal(false);
    }
    const handleDeclineConfirm = () => {
        // dispatch(declineVendorJobs({ schedule_id: declineModal?.item?.id }, submitCallback))
    }
    const handleChange = (e) => {
        // handle form change
        const id = e.target.dataset.value
        setSelectedItems(
            selectedItems.includes(id) ?
                selectedItems.filter((item) => item != id) :
                [...selectedItems, id]
        )
    };
    // const viewItemButtonRef = React.useRef()



    //#region TABLE HEAD 
    const renderTableHeader = React.useCallback(() => {
        const callBack = (dir, sortBy) => {
            setSortConfig({ sortBy, sortDirection: dir })
            dispatch(fetchMainAccountDashboardAppointments(currentPage, { sortBy: sortBy, sortDirection: dir, search: searchTerm }))
        }

        return (
            <tr>
                <th>#</th>
                <th>
                    <TableHeaderItem
                        title={t("table.appid", { defaultValue: "appid" })}
                        sortBy="appid"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th>
                    <TableHeaderItem
                        title={t("table.status", { defaultValue: "Status" })}
                        sortBy="status"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title={t("table.service", { defaultValue: "Service" })}
                        sortBy="type"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th>
                    <TableHeaderItem
                        title={t("table.date", { defaultValue: "Date" })}
                        sortBy="datetime"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title={t("table.language", { defaultValue: "Language" })}
                        sortBy="language"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th>
                    <TableHeaderItem
                        title={t("table.vendor", { defaultValue: "Vendor" })}
                        sortBy="interpreter"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

               
            </tr>
        )
    }, [selectAll, searchTerm, sortFields, currentPage, sortConfig, selectedItems, t]);
    //#endregion


    //#region TABLE BODY

    const renderTableContent = React.useCallback(() => {
        return (
            data?.map((item, index) => (
                <AppointmentListItem key={item?.id || index} item={item} index={index} handleAcceptButton={handleAcceptButton} handleDeclineShow={handleDeclineShow} current_page={current_page} pageLength={pageLength} />
            ))
        )
    }, [selectedItems, data, current_page, pageLength]);

    //#endregion


    const handleAcceptButton = React.useCallback((id) => {
        setActionAccept({
            show: true,
            item: { id },
        });
    }, [])

    const handleCloseActionButton = React.useCallback((id) => {
        setActionAccept({
            show: false,
            item: {}
        })
    }, [])

    const handleDeclineShow = React.useCallback((id) => {
        setDeclineModal({
            show: true,
            item: { id },
        });
    }, [])


    return (
        <div className='mt-4'>
            <ListLayout
                heading={t("dashboardAppointment.title", { defaultValue: "Dashboard Appointments" })}
                time={false}
                fullMainHead={'ms-3'}
                title=""
                renderTableHeader={renderTableHeader}
                renderTableContent={renderTableContent}
                fetchList={fetchMainAccountDashboardAppointments}
                selectedItems={selectedItems}
                handleDeclineConfirm={handleDeclineConfirm}
                refAddutton={refAddutton}
                addForm={addForm}
                showConfirmDialog={showConfirmDialog}
                handleAddPopUp={handleAddScheduleListPopUp}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                searchPlaceholder={t("table.searchInThisTable", { defaultValue: "Search in this table ..." })}
                addButtonDisabled={true}
                totalPages={totalPages}
                sortConfig={sortConfig}
                paginationParams={filters}
                noOfItems={total}
                pageLengthChange={setPageLength}
            >
                {declineModal.show && <ConfirmationModal onClose={hideConfirmDialog} isOpen={declineModal?.show} onConfirm={handleDeclineConfirm} confirmationText={t("appointment.declineConfirm", { defaultValue: "Are you sure you want to Decline?" })} />}
            </ListLayout>
        </div>
    )
}


const AppointmentListItem = React.memo(({
    item, index, current_page, pageLength
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const serial = useMemo(() => {
        return index + 1 + (current_page - 1) * pageLength;
    }, [current_page, pageLength]);

    const getStatusText = (status) => {
        if (!status) return t("common.nA", { defaultValue: "N/A" });
        const normalized = status.toString().toLowerCase();
        return t(`status.${normalized}`, { defaultValue: status });
    };

    return (
        <tr>
             <td className='p-0' style={getBackgroundStyle(item?.status)}>
                                        <div className={`eye_area ${
                                            (item?.status === 'cancelled' && item?.appointment_details?.is_billable_cancel == 1) 
                                                ? 'zebra_lines' 
                                                : ''
                                        } ${item?.appointment_details?.extra_mileage_request == 1 && 'extra-mileage'}`} style={getEyeStyle(item?.status)}>
                                            <Link to={`/user/appointments/view/${item?.id}`}><i className="fa-solid fa-eye"></i></Link>
                                        </div>
                                    </td>
            <td style={getBackgroundStyle(item?.status)}>
                {item?.appid ?
                    <Link className='link_preview' to={`/user/appointments/view/${item?.id}`}>
                        {item?.appid}
                    </Link>
                    : t("common.nA", { defaultValue: "N/A" })
                }
            </td>
            <td style={getBackgroundStyle(item?.status)} className='text-transform-capitalize'>
                {item?.status == 'cancelled' ? item?.appointment_details?.is_billable_cancel == 1 ? t("appointment.cancelledBillable", { defaultValue: 'Cancelled Billable' }) : getStatusText(item?.status) : getStatusText(item?.status)}
            </td>
            <td style={getBackgroundStyle(item?.status)}>
                {item?.type || t("common.nA", { defaultValue: "N/A" })}
            </td>
            <td style={getBackgroundStyle(item?.status)}>
                {item?.datetime ? (
                    item?.appointment_details?.timezone?.name
                        ? moment.tz(item.datetime, item.appointment_details.timezone.name).tz(item?.accounts?.timezone?.name).format('MMM D, YYYY hh:mm A')
                        : moment(item.datetime).format('MMM D, YYYY hh:mm A')
                ) : t("common.nA", { defaultValue: "N/A" })}
            </td>
            <td style={getBackgroundStyle(item?.status)}>
                {item?.language?.name || t("common.nA", { defaultValue: "N/A" })}
            </td>
            <td style={getBackgroundStyle(item?.status)}>
                {item?.interpreter?.user?.name || t("common.nA", { defaultValue: "N/A" })}
            </td>
            
        </tr>
    )
})
export default ListTable